<button (click)="onShowOverwriteValuesModal($any($event))"
        [class.at-ndc--disabled]="disableClick"
        class="at-ndc">
  @NDC
</button>
